import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './invoiceStreamMessages';
import MenuItemWithSecurity from '@/shared/components/MenuItemWithSecurity';
import AuthService, { functionalities, privileges, features } from '@/shared/services/AuthService';

const InvoiceStreamGlobalActionsButton = props => {
  const {
    intl,
    disabled,
    onSetInvoiceSchedule,
    onUpdateAmount,
    onUpdatePriceGrid,
    onSendEmail,
    onUpdateUser,
    onUpdateField,
    onUpdateMergeWith,
    onReprocessSchedule,
    onProcessNextSchedule,
    onExecuteTaskflowBilling,
    onAddRelationLabel,
  } = props;
  const hasTaskflowBilling = useMemo(() => AuthService.hasFeature(features.TaskflowBilling), []);

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.RelationGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="small"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        <MenuItemWithSecurity
          onSelect={onSetInvoiceSchedule}
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.SetInvoiceSchedule)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onUpdateAmount}
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.UpdateAmount)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onUpdatePriceGrid}
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.UpdatePriceGrid)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onUpdateUser}
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Update}
          id="global-actions-button-UpdateInvoicestreamUser"
        >
          {intl.formatMessage(messages.UpdateInvoiceStreamUser)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onUpdateField}
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.UpdateField)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onUpdateMergeWith}
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.UpdateMergeWith)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onSendEmail}
          functionality={functionalities.Relation}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.SendEmail)}
        </MenuItemWithSecurity>

        <MenuItemWithSecurity
          onSelect={onReprocessSchedule}
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Create}
        >
          {intl.formatMessage(messages.ReprocessInvoiceStreamSchedules)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onProcessNextSchedule}
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Create}
        >
          {intl.formatMessage(messages.ProcessNextInvoiceStreamSchedule)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onAddRelationLabel}
          functionality={functionalities.InvoiceDraft}
          privilege={privileges.Create}
        >
          {intl.formatMessage(messages.AddTagToRelation)}
        </MenuItemWithSecurity>

        {hasTaskflowBilling ? (
          <MenuItemWithSecurity
            onSelect={onExecuteTaskflowBilling}
            functionality={functionalities.InvoiceDraft}
            privilege={privileges.Create}
          >
            {intl.formatMessage(messages.ExecuteTaskflowBilling)}
          </MenuItemWithSecurity>
        ) : null}
      </DropdownButton>
    </span>
  );
};

InvoiceStreamGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  onSetInvoiceSchedule: PropTypes.func.isRequired,
  onUpdateAmount: PropTypes.func.isRequired,
  onUpdatePriceGrid: PropTypes.func.isRequired,
  onUpdateUser: PropTypes.func.isRequired,
  onUpdateField: PropTypes.func.isRequired,
  onUpdateMergeWith: PropTypes.func.isRequired,
  onReprocessSchedule: PropTypes.func.isRequired,
  onProcessNextSchedule: PropTypes.func.isRequired,
  onExecuteTaskflowBilling: PropTypes.func.isRequired,
  onAddRelationLabel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

InvoiceStreamGlobalActionsButton.defaultProps = { disabled: false };

export default injectIntl(InvoiceStreamGlobalActionsButton);
